import React from "react";

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16" data-testid="about-page">
      <div className="text-xs uppercase tracking-[0.2em] text-blue-600 font-bold">About Aloka</div>
      <h1 className="font-display text-5xl font-black tracking-tight text-slate-900 mb-6">A consulting firm for both sides of the world.</h1>
      <div className="prose prose-slate max-w-none">
        <p>Aloka Corporate & Legal Solutions is a consulting practice operating out of Vasai-Virar, Maharashtra,
          with a mandate to make compliance, capital and corporate counsel approachable for Indian SMEs and Indian-American
          founders. We combine in-house CAs with a vetted marketplace of independent professionals.</p>
        <p>Our India practice covers Accounting, Income Tax, GST, PF, ESIC, ROC compliance, MLFW, and end-to-end
          incorporation of Proprietorship, Partnership, LLP, Pvt Ltd, OPC, Society and NGO. We also assist in raising
          Business, Home, Personal, LAP and private funding.</p>
        <p>Our USA practice supports MSMEs with monthly bookkeeping, sales tax compliance and incorporation of LLC,
          C-Corp and S-Corp entities. We act as a one-stop interface for cross-border founders.</p>
        <p>Every assignment carries a quality-review based refund. If you are unhappy with the deliverable, our
          internal panel reviews the work and decides the appropriate refund. Independent professionals are paid out
          85% of the service value upon successful client approval; Aloka retains 15% as platform fee.</p>
      </div>
    </div>
  );
}
